export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8164.a9284b42.jpg";